import React from 'react'
import styles from './AdManager.module.css'
import { FaHome } from 'react-icons/fa';
import adlogo from '../Images/AdManagerLogo.png'
import Billlogo from '../Images/BillingLogo.png'
import { Link } from "react-router-dom";

const AdManager = () => {
    return (
        <>
            <div className={styles.home}>
                <div className={styles.side}>
                    <Link to="/home" className={styles.homeTitle}>
                        <FaHome size={22} className={styles.logo} />
                        <div className={styles.text}>Home</div>
                    </Link>
                    <Link to="/admanager" className={styles.manager}>
                        <div className={styles.admanag}><img src={adlogo} alt="" /></div>
                        <div className={styles.text}>Ad manager</div>
                    </Link>
                    <Link to="/billing" className={styles.manager1}>
                        <div className={styles.admanag}><img src={Billlogo} alt="" /></div>
                        <div className={styles.text}>Billing</div>
                    </Link>

                </div>
                <div className={styles.right}>
                    <div className={styles.inner}>
                        <div className={styles.cardsout}>
                            <div className={styles.card1}>
                                <div className={styles.textcrypto}>
                                    <div className={styles.heading}>Crypto Project</div>
                                    <div className={styles.para}>Reach out to crypto <br /> enthusiasts</div>
                                </div>
                                <div className={styles.lowerButton}>
                                    <button className={styles.createcom}>Create campaign</button>
                                </div>
                            </div>
                            <div className={styles.card2}>
                                <div className={styles.textcrypto}>
                                    <div className={styles.heading}>Local store</div>
                                    <div className={styles.para}>Advertise your local store on<br />people in your area</div>
                                </div>
                                <div className={styles.lowerButton}>
                                    <button className={styles.createcom}>Create campaign</button>
                                </div>
                            </div>
                            <div className={styles.card3}>
                                <div className={styles.textcrypto}>
                                    <div className={styles.heading}>Online shop</div>
                                    <div className={styles.para}>Adverise your products in a<br />gamified way</div>
                                </div>
                                <div className={styles.lowerButton}>
                                    <button className={styles.createcom}>Create campaign</button>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </>
    )
}

export default AdManager
